export const firebaseConfig = {
  apiKey: 'AIzaSyB_MT5jVb4uCxFH2Rq4IU08EX2I86plIpY',
  authDomain: 'myrepublic-customer.firebaseapp.com',
  databaseURL: 'https://myrepublic-customer-default-rtdb.firebaseio.com',
  projectId: 'myrepublic-customer',
  storageBucket: 'myrepublic-customer.appspot.com',
  messagingSenderId: '424199814939',
  appId: '1:424199814939:web:12b6dbde8a4d7933cc5dbe',
  measurementId: 'G-BN5SX9J8MD',
};